import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../api/pickupOrderRemote';

import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';

import OrderExceptionNote from './OrderExceptionNote';

interface OrderExceptionNoteContainerProps {
  receiveError: Function;
  number: string;
  handleClose: (type: string) => void;
};
  
interface OrderExceptionNoteContainerState {
  note: { note: string };
  attachments: string[];
};

class WhsOrderNoteContainer extends Component<OrderExceptionNoteContainerProps, OrderExceptionNoteContainerState> {

  state = {
    note: {
      note: ''
    },
    attachments: []
  }
  
  componentDidMount() {

    pickupOrderRemote.getGhaPoNote(this.props.number).then((resp: ApiResponse<{ note: string, attachments: string[] }>) => {

      const noteResp: { note: string, attachments: string[] } | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (noteResp) {
        this.setState({ note: {note: noteResp.note}, attachments: noteResp.attachments });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  render() {

    return (
      
      <OrderExceptionNote
        note={ this.state.note }
        orderNumber={ this.props.number }
        attachments={ this.state.attachments }
        handleClose={ this.props.handleClose }
      />
    )
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};
  
export default connect(null, mapDispatchToProps)(WhsOrderNoteContainer);
